import React from "react";
import SEO from "../components/SEO";
import legalData from "../data/legal.json";

export default function TermsOfUse() {
  return (
    <div className="bg-slate-50">
      <SEO
        title={legalData.terms?.title}
        description={legalData.terms?.description}
        ogType="website"
      />
      <section className="section-padding mx-auto w-full max-w-4xl">
        <p className="text-sm uppercase tracking-[0.2em] text-amber-600">
          Terms of Use
        </p>
        <h1 className="page-title mt-3">
          Manage Your Vastu Terms of Use
        </h1>
        <div className="card mt-6 space-y-4 p-6 text-sm text-slate-600">
          <p>
            This is a placeholder terms of use for Manage Your Vastu. Replace
            with legal content before launch.
          </p>
          <p>
            Use of Manage Your Vastu indicates acceptance of the terms and
            conditions.
          </p>
        </div>
      </section>
    </div>
  );
}
